webpackJsonp([6],{

/***/ "+0it":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var init = function init() {
  var _this = this;
  // 建议为了方便使用，这里可以包装window.Alert
  window.Alert = function (msg) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;

    _this.$message({
      showClose: true,
      message: msg,
      type: 'error',
      duration: duration
    });
  };

  window.Tips = function (msg) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;

    _this.$message({
      showClose: true,
      message: msg,
      type: 'info',
      duration: duration
    });
  };

  window.Warning = function (msg) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;

    _this.$message({
      showClose: true,
      message: msg,
      type: 'warning',
      duration: duration
    });
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  init: init
});

/***/ }),

/***/ "05nr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0xPk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1hB5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_PublicHeader_vue__ = __webpack_require__("XU2T");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_5bed7f87_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_PublicHeader_vue__ = __webpack_require__("bBez");
function injectStyle (ssrContext) {
  __webpack_require__("8PN6")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5bed7f87"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_PublicHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_5bed7f87_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_PublicHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "26cI":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkM4ODEwQjREN0NDNzExRTc5MzVBRDI3OEJFNTJFQTJCIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkM4ODEwQjRFN0NDNzExRTc5MzVBRDI3OEJFNTJFQTJCIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6Qzg4MTBCNEI3Q0M3MTFFNzkzNUFEMjc4QkU1MkVBMkIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6Qzg4MTBCNEM3Q0M3MTFFNzkzNUFEMjc4QkU1MkVBMkIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5HK+sBAAAAMUlEQVR42mL8DwQM2AEjEJMsx8RAZTD4DWSBhgcDnrAiSY6FnIAfjZTRSBnsBgIEGAATNgwkE+2xKAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "4Wz7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8PN6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9bN/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("rVsN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("2sCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("QmSG");

/**
 * ajax 模块，可以将 axios 替换成 $.ajax 等
 */



var GET_LANGUAGE_TYPE = '/get/i18n_type';
var GET_I18N = '/static/i18n/';
var GET_HEADER_LIST = '/headerList';
var PERMISSION_CHECK = '/permissionCheck';

var init = function init() {
  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (config) {
    // if (config.method === 'get' || 'post') {
    //   config.url += ('?access_token=' + (window.localStorage.access_token || ''));
    //   // config.url += ('?access_token=' + (window.localStorage.access_token || '') + '&path=' + location.href);
    // } else {
    //   if (!config.data) config.data = {};
    //   config.data['access_token'] = window.localStorage.access_token || '';
    //   config.data['path'] = location.href || '';
    // }
    if (config.url.indexOf(GET_LANGUAGE_TYPE) < 0 && config.url.indexOf(GET_HEADER_LIST) < 0 && config.url.indexOf(GET_I18N) < 0 && config.url.indexOf(PERMISSION_CHECK) < 0) {
      config.url = window.localStorage.gatewayDomain + config.url;
    }
    var cookies = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].getCookies();
    if (config.url.indexOf('?') < 0) {
      config.url += '?';
    }
    config.url += 'access_token=' + cookies['access_token'];
    if (!config.data) config.data = {};
    return config;
  }, function (err) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });

  // Add a response interceptor
  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(function (response) {
    var status = response.status,
        data = response.data;


    if (status === 200) {
      // 如果不出现错误，直接向回调函数内输出 data
      if (data.error === 'SUCCESS') {
        return data;
      } else {
        return data;
      }
    } else {
      return response;
    }
  }, function (error) {
    var response = error.response;

    // 这里处理错误的 http code

    if (response.status === 404) {
      console.log('404 error %o' + error);
    }

    // Do something with response error
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  init: init
});

/***/ }),

/***/ "L8YR":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjcyQTdDNURBN0NCRTExRTc5RDA1QkRDNUVCQjI5OUZBIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjcyQTdDNURCN0NCRTExRTc5RDA1QkRDNUVCQjI5OUZBIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NzJBN0M1RDg3Q0JFMTFFNzlEMDVCREM1RUJCMjk5RkEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NzJBN0M1RDk3Q0JFMTFFNzlEMDVCREM1RUJCMjk5RkEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4zsdpyAAAByElEQVR42oRSSU4CURCt/jSEIRASdcGGEDiAC1x4BE8gwYTTsRA9iQm48AIuSAiB7maeh/6+V3YbVlhJU02/Gl69KsdaK+fzWWiJRMKs1+vG8Xhs4u8jsDt4z3Gcj2Qy+ZrL5d6AhYx1XVeci+TqYrF4h6+n02lJpVKCJCGOBNlutxKG4WehUHhGzDeTFTydTtXhcDiaz+f2moGVHY/Ho8PhUEUhTTbT6bSLx/JBl6sFNpuN9X2/i2QjqPYymUwU2O/3djabWQAa1O/31cdYbGyyWq1eXHxsZbNZFYxUkKweoOx2O8E4ioGqlMtlYWwmkxEUbRmI8gAlNQAfBFU1MZ/PS6VSkVKppIKiiYpGi8S8N3i/parRqlRhFmN1CKiBxWJRhSVOi+JvmOwToMWedLkKdmc3dr3EIx8YvPSwqr+K7MrkwWCg9JfLpX7DgcQdde/I+3IBtDHrE+nhAJQug6IAFYh0jTGK0cgGzNpU1nie18WHq/sFG10j2NggCH73zLVgptoI9l8BnK/FOLywml5YlKwFwKDH6jwIHgqNPj4edOwxjjtnnsMfzkfD/Aa0GhCwibnrXCNVpaiYsQPROsBCasJt/AgwAPMmBJT8kE1ZAAAAAElFTkSuQmCC"

/***/ }),

/***/ "LkWc":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjc4MUZENDg0N0NCRTExRTc4Njk1Q0UyRDZDMzI1N0ExIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjc4MUZENDg1N0NCRTExRTc4Njk1Q0UyRDZDMzI1N0ExIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NzgxRkQ0ODI3Q0JFMTFFNzg2OTVDRTJENkMzMjU3QTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NzgxRkQ0ODM3Q0JFMTFFNzg2OTVDRTJENkMzMjU3QTEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz523M9HAAAA9ElEQVR42oxTAQ2DMBAsZAZqoRawgIVNQi3UApPAJGCBSdgkUAmdhO673JOj65I1uYTn767P/9PlnE3jDAJH8Utw/2IVMeEsWHP7bALPfBYGkFaQLGEULMiHWuyRmMlsQCUOsUU+I7eLE8rSeKZyE6pJMNj0Er5Vy5kQL7iZP0fzj/J8oq4+BVbgBVFwoc6bVrd7ei7iMwxu9H6sxA6jO4gdVRErcaTKRjXq1QXlRTIqxACyCmdwrrokljpq0Aw+2umE3D7CekECxZPOE7HHzPexmcZsFyLqhg0w2CAc6vX8Z7cnmH343Y+/ytKIDHX7cN4CDADqcuy6L8XQMAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("sEFh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_0e9fdd42_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("xO6S");
function injectStyle (ssrContext) {
  __webpack_require__("05nr")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_0e9fdd42_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("yf3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__("PnPl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_ajax__ = __webpack_require__("9bN/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_request__ = __webpack_require__("fiA/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__interface__ = __webpack_require__("wtao");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_all__ = __webpack_require__("0xPk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_common_css_theme_index_css__ = __webpack_require__("4Wz7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_common_css_theme_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_common_css_theme_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_common_css_pages_css__ = __webpack_require__("sywW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_common_css_pages_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_common_css_pages_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_font_css_font_awesome_css__ = __webpack_require__("ZTmQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_font_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_font_css_font_awesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__("QmSG");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.













window.localStorage.permissionCheckUrl = 'platform/v1/access/resources';
window.localStorage.defaultLanguage = 'ZH_CN';

// 动态设置环境
console.log("production");
if (false) {
  // dev环境
  window.localStorage.gatewayDomain = 'https://dev-api.zjlh.lan/';
  window.localStorage.serviceName = 'https://dev-bmp-policy.zjlh.lan';
  window.localStorage.loginUrl = 'https://dev-bmp.zjlh.lan';
  window.localStorage.dashboardUrl = 'https://dev-bmp.zjlh.lan/#/dashboard';
  window.localStorage.cookieDomain = '.zjlh.lan';
} else if (false) {
  // stag预发布环境
  window.localStorage.gatewayDomain = 'https://stag-api.gc-life.cn/';
  window.localStorage.serviceName = 'https://stag-bmp-policy.gc-life.cn';
  window.localStorage.loginUrl = 'https://stag-bmp.gc-life.cn';
  window.localStorage.dashboardUrl = 'https://stag-bmp.gc-life.cn/#/dashboard';
  window.localStorage.cookieDomain = '.gc-life.cn';
} else if (true) {
  // 生产环境
  window.localStorage.gatewayDomain = 'https://api.gc-life.com/';
  window.localStorage.serviceName = 'https://bmp-policy.gc-life.com';
  window.localStorage.loginUrl = 'https://bmp.gc-life.com/#/';
  window.localStorage.dashboardUrl = 'https://bmp.gc-life.com/#/dashboard';
  window.localStorage.cookieDomain = '.gc-life.com';
}
console.log(window.localStorage.gatewayDomain);

// 插件配置
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui___default.a);

__WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].init();

// axios 统一配置
__WEBPACK_IMPORTED_MODULE_4__services_ajax__["a" /* default */].init();

// 设置请求头
__WEBPACK_IMPORTED_MODULE_5__services_request__["a" /* default */].init();

// 此处调用国际化接口，获取国际化数据
var language = __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].getCookie('language');
if (!language || !language.length) {
  language = window.localStorage.defaultLanguage;
}
__WEBPACK_IMPORTED_MODULE_6__interface__["a" /* default */].getI18n(language).then(function () {
  /* eslint-disable no-new */
  new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] },
    data: {
      eventBus: new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]()
    }
  });
});

/***/ }),

/***/ "QmSG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_index__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("2sCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var init = function init() {
  __WEBPACK_IMPORTED_MODULE_0__router_index__["a" /* default */].beforeEach(function (to, from, next) {
    if (to.matched && to.matched.length && to.matched[0].path) {
      checkPermission(to.matched[0].path).then(function (data) {
        if (data === 'true') {
          next();
        }
      });
    } else {
      checkPermission(to.path).then(function (data) {
        if (data === 'true') {
          next();
        }
      });
    }
  });
};

// Return the document's cookies as an object of name/value pairs.
function getCookies() {
  var cookies = {};
  var all = document.cookie;
  if (all === '') return cookies;
  var list = all.split('; ');
  for (var i = 0; i < list.length; i++) {
    var cookie = list[i];
    var p = cookie.indexOf('=');
    var name = cookie.substring(0, p);
    var value = cookie.substring(p + 1);
    value = decodeURIComponent(value);
    cookies[name] = value;
  }
  return cookies;
}

function getCookie(name) {
  var cookies = getCookies();
  var value = '';
  if (cookies && cookies[name]) {
    value = cookies[name];
  }
  return value;
}

function clearCookie() {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  document.cookie = 'access_token' + '=;domain=' + window.localStorage.cookieDomain + ';expires=' + exp.toGMTString() + ';path=/';
  document.cookie = 'username' + '=;domain=' + window.localStorage.cookieDomain + ';expires=' + exp.toGMTString() + ';path=/';
  document.cookie = 'language' + '=;domain=' + window.localStorage.cookieDomain + ';expires=' + exp.toGMTString() + ';path=/';
}

// set cookie
function setCookie(name, value) {
  var cookie = name + '=' + encodeURIComponent(value);
  document.cookie = cookie;
}

function checkPermission(path) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(window.localStorage.permissionCheckUrl, {
    params: {
      requestUrl: path,
      httpMethod: 'GET',
      serviceName: window.localStorage.serviceName,
      type: 'FRONTEND_URL'
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  getCookies: getCookies,
  setCookie: setCookie,
  checkPermission: checkPermission,
  getCookie: getCookie,
  clearCookie: clearCookie
});

/***/ }),

/***/ "XU2T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("3cXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interface__ = __webpack_require__("wtao");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("QmSG");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      serviceName: '',
      username: '',
      I18n: window.I18n,
      menuList: '',
      dashboard: window.localStorage.dashboardUrl,
      isShow: Number(sessionStorage.getItem('isShow'))
    };
  },

  // 监听路由name的变化
  watch: {
    name: function name() {
      if (this.$route.name === 'CheckList') {
        this.isShow = 0;
      }
    }
  },
  computed: {
    // 计算 路由name
    name: function name() {
      return this.$route.name;
    }
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__interface__["a" /* default */].getHeaderList().then(function (data) {
      // this.menuList = data.data.menuList;
      _this.menuList = data.data.grantedSubmenu;
      _this.serviceName = data.data.serviceName;
    });
    this.username = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].getCookie('username');
  },

  methods: {
    addClass: function addClass(index) {
      this.isShow = index;
      // 会话存储当前isShow  转换为json存储
      sessionStorage.setItem('isShow', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.isShow));
    },
    handleCommand: function handleCommand(command) {
      if (command === 'logout') {
        __WEBPACK_IMPORTED_MODULE_1__interface__["a" /* default */].logout().then(function (data) {
          // 清空cookie 跳转到登录页
          __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].clearCookie();
          window.location.href = window.localStorage.loginUrl;
        });
      }
    }
  }
});

/***/ }),

/***/ "YRwl":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjc0NUJBODlGN0NCRTExRTdBMzE4QTlEMjA4NDM5NDI0IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjc0NUJBOEEwN0NCRTExRTdBMzE4QTlEMjA4NDM5NDI0Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NzQ1QkE4OUQ3Q0JFMTFFN0EzMThBOUQyMDg0Mzk0MjQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NzQ1QkE4OUU3Q0JFMTFFN0EzMThBOUQyMDg0Mzk0MjQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz60nXBeAAAA2klEQVR42nTRu65BQRTG8VHKUXgAhZyIREO06OkolafSeQSeQO8FVC6FRLRKUXgFtygUJ9sliMr2X7F2MibbJL9i1v7WZGZt4/u+QRwTldCa7Q9DyckmpsUkbhggYoXrePjv1ZfCVMM/WGNlNdjhq+ylOMNFg7JOSKHmhKtySHCVMXa4Y4mWHvIRDhoCUeTQxlHDHir2ANxpyElnDf+jid9vDfYDPQ3PsUfWbXCnUUbautomaJJwKWwaqoCDftsiI8WuFs5OOKypIT+oY4x5YoSFCV95FNF7CTAAbovOVlqk3PgAAAAASUVORK5CYII="

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("yf3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("mB6C");



var CheckList = function CheckList() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "ymRS"));
};
var ShouldList = function ShouldList() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "LLbb"));
};
var ActualList = function ActualList() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "MIHy"));
};
var ActualDetail = function ActualDetail() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "u9qL"));
};
// const ActualDetail = () => import('../pages/ActualList/index.vue')
// const ApplyDetails = () => import('../pages/ApplyDetails/index.vue')
var ShouldListDetail = function ShouldListDetail() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "hcPT"));
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'CheckList',
    component: CheckList
  }, {
    path: '/ShouldList',
    name: 'ShouldList',
    component: ShouldList
  }, {
    path: '/ActualList',
    name: 'ActualList',
    component: ActualList
  }, {
    path: '/CheckList',
    name: 'CheckList',
    component: CheckList
  }, {
    path: '/ShouldListDetail',
    name: 'ShouldListDetail',
    component: ShouldListDetail
  }, {
    path: '/ActualDetail',
    name: 'ActualDetail',
    component: ActualDetail
  }]
}));

/***/ }),

/***/ "ZTmQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bBez":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Header"},[_c('div',[_c('ul',{staticClass:"menu"},[_c('li',[_c('a',{attrs:{"href":_vm.dashboard}},[_c('img',{attrs:{"src":__webpack_require__("26cI"),"alt":"主菜单"}})])]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.serviceName))])]),_vm._v(" "),_c('ul',{staticClass:"menuList"},_vm._l((_vm.menuList),function(list,index){return _c('li',{class:{isShow: index === _vm.isShow},on:{"click":function($event){$event.stopPropagation();return _vm.addClass(index)}}},[_c('router-link',{attrs:{"to":list.value},domProps:{"textContent":_vm._s(list.internationalText)}})],1)}),0),_vm._v(" "),_c('ul',{staticClass:"iconList"},[_c('li',[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":__webpack_require__("LkWc"),"alt":"@"}})])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":__webpack_require__("YRwl"),"alt":"设置"}})])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":__webpack_require__("f4jB"),"alt":"对话"}})])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":__webpack_require__("L8YR"),"alt":"对话"}})])],1),_vm._v(" "),_c('li',{staticClass:"headerActive"},[_c('el-dropdown',{on:{"command":_vm.handleCommand}},[_c('span',{staticClass:"el-dropdown-link"},[_vm._v("\n            "+_vm._s(_vm.username)),_c('i',{staticClass:"el-icon-arrow-down el-icon-caret-bottom"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"logout"}},[_vm._v(_vm._s(_vm.I18n.logout))])],1)],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f4jB":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAPCAYAAAACsSQRAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjc2MTM1QzVGN0NCRTExRTdBQjFBQUY0NkYyRTBEMTg5IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjc2MTM1QzYwN0NCRTExRTdBQjFBQUY0NkYyRTBEMTg5Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NzYxMzVDNUQ3Q0JFMTFFN0FCMUFBRjQ2RjJFMEQxODkiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NzYxMzVDNUU3Q0JFMTFFN0FCMUFBRjQ2RjJFMEQxODkiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6XP+DTAAAA9UlEQVR42mJkQAP////nA1JMyEKMjIwfGQgBoEZGIC4G4mf/sQOQeBlIHT5DJv0nDszEZYDxf9KAGboZLEAcgMSfA8RXsdhlAMTxUHYoEJ9Cd8kCEl2yCIiF0V3yFIk/F4ivIPGzgVgFzVUvgHgd0CAQOwQYc6/JCRMvIP4BZW9E9lI/kQZMQ1P7D4gFkNNJARA/waEZJF4ExCVY5OTQA1kBSfIkENsBsT8QpwHxESwGPAdiJnRD5JEM4AdiFyD+hcN1IK+EY0t4zNDkLYAkZgDEU4F4AxB/gxpwDohtGMgBQI2eUJdNYKAEAA1wBGITZDGAAAMAMOgcffbw2dIAAAAASUVORK5CYII="

/***/ }),

/***/ "fiA/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("2sCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/**
 * Created by c0001 on 2018/6/15.
 */


// 设置公共请求头
var init = function init() {
  var url = window.location.search.toString();
  var arr = [];
  var isArr = {};
  arr = url.split('&');
  arr.forEach(function (l) {
    l = l.split('=');
    isArr[l[0]] = l[1];
  });
  __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['deviceChannel'] = 'gclife_bmp_pc';
  __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['language'] = window.localStorage.defaultLanguage;
  if (isArr.osType) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['osType'] = isArr.osType;
  } else {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['osType'] = '';
  };
  if (isArr.deviceId) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['deviceId'] = isArr.deviceId;
  } else {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['deviceId'] = '';
  };
  if (isArr.appVersion) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['appVersion'] = isArr.appVersion;
  } else {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['appVersion'] = '';
  };
  if (isArr.district) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['district'] = isArr.district;
  } else {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['district'] = '';
  };
  if (isArr.phoneModel) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['phoneModel'] = isArr.phoneModel;
  } else {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['phoneModel'] = '';
  };
  if (isArr.osVersion) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['osVersion'] = isArr.osVersion;
  } else {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['osVersion'] = '';
  };
  if (isArr.coordiate) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['coordiate'] = isArr.coordiate;
  } else {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['coordiate'] = '';
  };
  if (isArr.networkType) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['networkType'] = isArr.networkType;
  } else {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['networkType'] = '';
  };
  if (isArr.ipAddress) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['ipAddress'] = isArr.ipAddress;
  } else {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['ipAddress'] = '';
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  init: init
});

/***/ }),

/***/ "sEFh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PublicHeader__ = __webpack_require__("1hB5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_error__ = __webpack_require__("+0it");
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    publicHeader: __WEBPACK_IMPORTED_MODULE_0__components_PublicHeader__["a" /* default */]
  },
  computed: {
    height: function height() {
      return document.documentElement.clientHeight - 46;
    }
  },
  mounted: function mounted() {
    // 全局错误初始化
    __WEBPACK_IMPORTED_MODULE_1__services_error__["a" /* default */].init.call(this);
  }
});

/***/ }),

/***/ "sywW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wtao":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("2sCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var ajax = {
  // 获取i18n种类
  GET_LANGUAGE_TYPE: '/get/i18n_type',

  // 获取首页menuList
  GET_MENU_LIST: 'homePageMenuImgList'

  // 获取头部导航菜单
  // GET_HEADER_LIST: '/headerList',
};

// 获取有权限的子菜单
var GET_GRANTED_SUBMENU = 'platform/v1/resources/granted/submenu';

// 获取单个影像件
var GET_IMAGE_BYTE = 'attachment/v1/media/byte?';

// 机构
var SALE_BRANCHS = 'https://dev-api.zjlh.lan/apply/v1/input/salebranchs?';

// 异常问题
var ABNORMAL_PROBLEM = 'https://dev-api.zjlh.lan/agent/v1/process/commission/exception/questions?';

// mock公共部分
var API_PATH_PRE_FIX = '/api';

var FIRST_PARAM_JOINT_MARK = '?';
// 退出系统
var LOGOUT = 'auth/user/logout';
// 增加前缀
var INTERFACE = {};
for (var key in ajax) {
  INTERFACE[key] = API_PATH_PRE_FIX + ajax[key];
}

/**
 * 获取 i18n 的种类
 */
function getI18nType() {
  // 这里需要先调用后端保存的语言
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(INTERFACE.GET_LANGUAGE_TYPE);
}

/**
 * 获取i18n 配置json
 *
 * @param language
 * @private
 */
function getI18n() {
  var language = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ZH_CN';

  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/static/i18n/' + language + '/index.json' + '?').then(function (data) {
    window.I18n = data;
  });
}

/**
 * 获取头部导航菜单
 */
// function getHeaderList() {
//   return axios.get(INTERFACE.GET_HEADER_LIST).catch(function (error) {
//     console.log(error)
//   });
// }

function getHeaderList() {
  var data = {
    parentMenuValue: '/',
    serviceName: window.localStorage.serviceName,
    httpMethod: 'GET',
    parentType: 'FRONTEND_DOMAIN',
    childType: 'FRONTEND_URL'
  };
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(GET_GRANTED_SUBMENU + '?', { params: data }).catch(function (error) {
    console.log(error);
  });
}

/**
 * 获取首页menuList
 */
function getMenuList() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(INTERFACE.GET_MENU_LIST).catch(function (error) {
    window.Alert(error);
  });
}

/**
 * 获取单个影像件
 * @param data
 * @returns {Promise.<T>}
 */
function getImageByte(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(GET_IMAGE_BYTE, {
    params: data
  }).catch(function (error) {
    window.Alert(error);
  });
}

/**
 * 获取机构
 */
function getSaleBarnchs() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(SALE_BRANCHS).catch(function (error) {
    window.Alert(error);
  });
}

/**
 * 获取异常问题
 */
function getAbnormalProblem() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(ABNORMAL_PROBLEM).catch(function (error) {
    window.Alert(error);
  });
}

var baseUrl = 'finance';

function getsaleList() {
  var c = 'platform/v1/manager/branch/trees';
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(c).catch(function (error) {
    window.Alert(error);
  });
}

function logout() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(LOGOUT + FIRST_PARAM_JOINT_MARK).catch(function (error) {
    window.Alert(error);
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getI18n: getI18n,
  getI18nType: getI18nType,
  getHeaderList: getHeaderList,
  getImageByte: getImageByte,
  getSaleBarnchs: getSaleBarnchs,
  getAbnormalProblem: getAbnormalProblem,
  baseUrl: baseUrl,
  getsaleList: getsaleList,
  logout: logout,
  getMenuList: getMenuList
});

/***/ }),

/***/ "xO6S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('publicHeader'),_vm._v(" "),_c('router-view',{attrs:{"height":_vm.height}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.d843f298f74827897d69.js